import { render, staticRenderFns } from "./industrial-internet.vue?vue&type=template&id=b849a2ee&scoped=true&"
import script from "./industrial-internet.vue?vue&type=script&lang=js&"
export * from "./industrial-internet.vue?vue&type=script&lang=js&"
import style0 from "./industrial-internet.vue?vue&type=style&index=0&id=b849a2ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849a2ee",
  null
  
)

export default component.exports